import { Theme } from '@emotion/react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { FunctionComponent } from 'react';

export interface PaidTagProps {
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            alignItems: 'center',
            padding: '11px 10px',
            backgroundColor: '#5E8677',
            borderRadius: 50
        },
        icon: {
            color: 'white',
            marginRight: 8
        },
        text: {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '100%',
            color: 'white'
        }
    })
);

export const PaidTag: FunctionComponent<PaidTagProps> = props => {
    const classes = useStyles();

    return (
        <Box className={clsx(classes.container, props.className)}>
            <FontAwesomeIcon
                icon={faCircleCheck}
                className={classes.icon}
            />
            <Typography className={classes.text}>Paid</Typography>
        </Box>
    );
};

export default PaidTag;
